import Axios from 'axios';
import * as actionTypes from '../../store/actions/actionTypes';

export const authStart = () => {
	return {
		type: actionTypes.AUTH_START,
	};
};

export const authSuccess = (token, username) => {
	return {
		type: actionTypes.AUTH_SUCCESS,
		token: token,
		username: username,
	};
};

export const authFail = error => {
	return {
		type: actionTypes.AUTH_FAIL,
		error: error,
	};
};

export const setAuthRedirectPath = path => {
	return {
		type: actionTypes.SET_AUTH_REDIRECT_PATH,
		path: path,
	};
};

export const checkAuthTimeout = expirationTime => {
	return dispatch => {
		setTimeout(() => {
			dispatch(logout());
		}, expirationTime * 1000);
	};
};

export const logout = () => {
	sessionStorage.removeItem('token');
	sessionStorage.removeItem('username');
	sessionStorage.removeItem('expirationDate');
	return {
		type: actionTypes.AUTH_LOGOUT,
	};
};

export const auth = (username, password) => {
	return dispatch => {
		dispatch(authStart());
		const authData = {
			username: username,
			password: password,
			returnSecureToken: true,
		};
		Axios.post(process.env.REACT_APP_AUTH_URL, authData)
			.then(response => {
				//console.log(response);
				const expirationDate = new Date(new Date().getTime() + response.data.expiresIn * 1000);
				sessionStorage.setItem('token', response.data.token);
				sessionStorage.setItem('username', response.data.username);
				sessionStorage.setItem('expirationDate', expirationDate);

				dispatch(authSuccess(response.data.token, response.data.username));
				dispatch(checkAuthTimeout(response.data.expiresIn));
			})
			.catch(err => {
				dispatch(authFail(err.response.data.error));
			});
	};
};

export const authCheckState = () => {
	return dispatch => {
		const token = sessionStorage.getItem('token');
		if (!token) {
			dispatch(logout());
		} else {
			const expirationDate = new Date(sessionStorage.getItem('expirationDate'));
			if (expirationDate <= new Date()) {
				dispatch(logout());
			} else {
				const username = sessionStorage.getItem('username');
				dispatch(authSuccess(token, username));
				dispatch(checkAuthTimeout((expirationDate.getTime() - new Date().getTime()) / 1000));
			}
		}
	};
};
